import { createModal } from '@blocksuite/affine-components/context-menu';
import { CloseIcon } from '@blocksuite/icons/lit';
import { ShadowlessElement } from '@blocksuite/std';
import { css, html, type TemplateResult } from 'lit';
import { property } from 'lit/decorators.js';

export class CenterPeek extends ShadowlessElement {
  static override styles = css`
    center-peek {
      flex-direction: column;
      position: absolute;
      top: 5%;
      left: 5%;
      width: 90%;
      height: 90%;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
      border-radius: 12px;
    }

    .side-modal-content {
      flex: 1;
      overflow-y: auto;
    }
  `;

  override render() {
    return html`
      <style>
        .center-peek-close-btn {
          position: absolute;
          right: -36px;
          top: 8px;
          width: 28px;
          height: 28px;
          padding: 0;
          background: var(--streamlain-background-secondary-color);
          border: 1px solid var(--streamlain-border-color);
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 18px;
          color: var(--streamlain-text-primary-color);
        }
        .center-peek-close-btn:hover {
          background: var(--streamlain-hover-color);
        }
      </style>
      <button
        @click="${this.close}"
        title="Close (ESC)"
        class="center-peek-close-btn"
      >
        ${CloseIcon()}
      </button>
      ${this.content}
    `;
  }

  @property({ attribute: false })
  accessor close: (() => void) | undefined = undefined;

  @property({ attribute: false })
  accessor content: TemplateResult | undefined = undefined;
}

export const popSideDetail = (template: TemplateResult) => {
  return new Promise<void>(res => {
    const modal = createModal(document.body);
    modal.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    const close = () => {
      modal.remove();
      res();
    };
    const sideContainer = new CenterPeek();
    sideContainer.content = template;
    sideContainer.close = close;
    modal.onclick = e => e.target === modal && close();
    modal.append(sideContainer);
  });
};
